import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ApiService } from 'Src/ng2/shared/services/api-service/api-service';
import { IPartner } from 'Src/ng2/shared/typings/interfaces/partner.interface';
import { ENTITY_TYPE } from 'Src/ng2/shared/typings/types/entity-type.types';
import { UrlNavigationService } from 'Src/ng2/shared/services/url-navigation/url-navigation.service';

@Injectable()
export class ShelterIdResolver implements Resolve<any> {
  constructor (private apiService: ApiService) {}
  resolve (route: ActivatedRouteSnapshot): Observable<IPartner> | Observable<never> {
    // This resolver is only meant to run on entity-type shelter
    if (UrlNavigationService.getEntityType(route) !== ENTITY_TYPE.SHELTER) return of(null);
    const shelterId = UrlNavigationService.getEntityId(route);
    const params = {
      type: 'shelter',
      _id: shelterId,
    };
    const projections = ['partnerName', 'subLocations'];
    return this.apiService.getPartner({ params, projections });
  }
}
